import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import {
  serverChangeEnvironmentMutationArgs,
  ServerChangeEnvironmentMutationArgs
} from '../types/server-change-environment-mutation-args'
import { Server, serverType } from '../types/server'

import { findByIDAndOrganizationID } from '../queries/helpers/server'

export const changeServerEnvironment: GraphQLFieldConfig<
  any,
  Context,
  ServerChangeEnvironmentMutationArgs
> = {
  description: "Change a server's environment",
  type: new GraphQLNonNull(serverType),
  args: serverChangeEnvironmentMutationArgs,
  resolve: async (_source, args, context: Context): Promise<Server> => {
    const { input } = args

    if (!input) {
      throw new Error('mutation input parameter is required')
    }

    const { id, organizationID, environment } = input

    const { connector } = context

    await connector.put(`/${organizationID}/servers/${id}/environment`, {
      environment
    })

    return findByIDAndOrganizationID(id, organizationID, connector)
  }
}
